// Utilities
import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    devicesDrawerOpen: false,
    familygroupsDrawerOpen: false,
  }),
  actions: {
    openDevicesDrawer () {
      this.devicesDrawerOpen = true
    },
    openFamilyGroupsDrawer () {
      this.familygroupsDrawerOpen = true
    },
  },
})
